// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/compliance/modals/shared/ModalSection.jsx

import React from "react";
import { Section } from "../../../../design-system/components";

function normalizeTone(tone) {
  const value = String(tone || "").trim().toLowerCase();

  if (["ok", "healthy", "passed", "complete"].includes(value)) {
    return "success";
  }
  if (["warn", "attention", "pending"].includes(value)) {
    return "warning";
  }
  if (["danger", "error", "critical", "failed"].includes(value)) {
    return "danger";
  }
  if (["info", "informational", "default"].includes(value)) {
    return "informational";
  }
  return "neutral";
}

export default function ModalSection({
  title,
  description,
  badge,
  badgeTone = "default",
  children,
}) {
  return (
    <Section
      title={title}
      description={description}
      badge={badge}
      badgeTone={normalizeTone(badgeTone)}
      density="default"
    >
      {children}
    </Section>
  );
}
